import type { AgentApiCandidateFormsShow } from '@/types/serializers';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UpdateCandidateFormParams {
  title?: string;
  description?: string;
  status?: 'draft' | 'published';
  terms_of_service_url?: string;
  privacy_policy_url?: string;
  logo?: File | null;
  color_type?: 'white' | 'purple' | 'blue' | 'lightblue' | 'green' | 'black' | 'orange';
}

/**
 * フォーム更新用のフック
 */
export default function useUpdateCandidateForm() {
  const queryClient = useQueryClient();
  const token =
    (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content || '';

  return useMutation({
    mutationFn: async (params: UpdateCandidateFormParams) => {
      const formData = new FormData();
      formData.append('candidate_form[title]', params.title || '');
      if (params.description !== undefined) {
        formData.append('candidate_form[description]', params.description || '');
      }
      if (params.status !== undefined) {
        formData.append('candidate_form[status]', params.status);
      }
      if (params.terms_of_service_url !== undefined) {
        formData.append('candidate_form[terms_of_service_url]', params.terms_of_service_url || '');
      }
      if (params.privacy_policy_url !== undefined) {
        formData.append('candidate_form[privacy_policy_url]', params.privacy_policy_url || '');
      }
      if (params.logo) {
        formData.append('candidate_form[logo]', params.logo);
      }
      if (params.color_type !== undefined) {
        formData.append('candidate_form[color_type]', params.color_type);
      }

      const response = await fetch('/agent/api/candidate_forms', {
        method: 'PATCH',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        credentials: 'same-origin',
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.errors?.[0] || 'フォームの更新に失敗しました');
      }

      const data: AgentApiCandidateFormsShow = await response.json();
      return data;
    },
    onSuccess: () => {
      // フォーム一覧のキャッシュを無効化して再取得
      queryClient.invalidateQueries({ queryKey: ['candidate_forms'] });
    },
  });
}
